import React from 'react';
import styled from 'styled-components';

import { padding, fonts } from '../GlobalStyle';
import { calc4k } from '../utilities';

import image0 from '../data/images/featured_image_0.jpeg';
import image1 from '../data/images/featured_image_1.jpeg';
import image2 from '../data/images/featured_image_2.jpeg';

const FEATURED_EVENTS = [
    `33rd Annual Japanese New Year's Bell-Ringing
    Ceremony`,
    'Tour, Talk & Tea: Meuseum Objects Docents Never Talk About',
    'Changing And Unchanging Things: Noguchi And Hasegawa in Postwar Japan'
];

export default function FeaturedEvents() {
    return (
        <Container>
            <NoEventsContainer>
                <NoEventsText>No more events for today</NoEventsText>
            </NoEventsContainer>
            <FeaturedEvent>
                <ImageContainer image={image0} />
                <EventDescContainer>
                    <EventDescTopContainer>
                        <EventDescTopLeft>COMING UP</EventDescTopLeft>
                        <EventDescTopRight>
                            Friday, Dec 29 11:00PM
                        </EventDescTopRight>
                    </EventDescTopContainer>
                    <EventDescBottom>{FEATURED_EVENTS[0]}</EventDescBottom>
                </EventDescContainer>
            </FeaturedEvent>
            <FeaturedEvent>
                <ImageContainer image={image1} />
                <EventDescContainer>
                    <EventDescTopContainer>
                        <EventDescTopLeft>COMING UP</EventDescTopLeft>
                        <EventDescTopRight>
                            Mon, Jan 07 12:30PM
                        </EventDescTopRight>
                    </EventDescTopContainer>
                    <EventDescBottom>{FEATURED_EVENTS[1]}</EventDescBottom>
                </EventDescContainer>
            </FeaturedEvent>
            <FeaturedEvent>
                <ImageContainer image={image2} />
                <EventDescContainer>
                    <EventDescTopContainer>
                        <EventDescTopLeft>COMING UP</EventDescTopLeft>
                        <EventDescTopRight>
                            Wed, Jan 15 3:00PM
                        </EventDescTopRight>
                    </EventDescTopContainer>
                    <EventDescBottom>{FEATURED_EVENTS[2]}</EventDescBottom>
                </EventDescContainer>
            </FeaturedEvent>
        </Container>
    );
}

const Container = styled.div`
    flex-direction: column;
`;

const NoEventsContainer = styled.div`
    position: relative;
    height: ${calc4k(763)};
    font-size: ${calc4k(50)};
    font-weight: ${calc4k(50)};
    background-color: black;
    color: #d8d8d8;
    /* color: #afafaf; */
`;

const NoEventsText = styled.div`
    font-family: ${fonts.headline};
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const FeaturedEvent = styled.div`
    border-top: 1px solid #383736;
    display: flex;
    height: ${calc4k(950)};
    padding: ${calc4k(211)} 0 ${calc4k(211)} ${padding.side};
`;

const ImageContainer = styled.div`
    width: ${calc4k(600)};
    height: ${calc4k(500)};
    background-image: url(${p => p.image});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
`;

const EventDescContainer = styled.div`
    font-family: ${fonts.headline};
    display: flex;
    flex-direction: column;
    width: ${calc4k(1328)};
    padding-left: ${padding.side};
`;

const EventDescTopContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const EventDescTopLeft = styled.div`
    font-family: ${fonts.headline};
    color: #afafaf;
    text-transform: uppercase;
    font-size: ${calc4k(50)};
    font-weight: 500;
`;

const EventDescTopRight = styled.div`
    font-family: ${fonts.headline};
    font-size: ${calc4k(50)};
    font-weight: 500;
`;

const EventDescBottom = styled.div`
    margin-top: ${calc4k(50)};
    font-size: ${calc4k(80)};
    line-height: ${calc4k(140)};
    font-weight: 500;
`;
